import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'mapbox-gl/dist/mapbox-gl.css';

import ReactGA from 'react-ga';
// Initialize React Ga with your tracking ID
//commente in test !!
//ReactGA.initialize('G-360WKNZ3P8');
//ReactGA.pageview(window.location.href);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/*var basename = '/'

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  basename = '/studio';
}*/


root.render(
  /*<React.StrictMode>
    <App />
  </React.StrictMode>*/
  <App />
  /*<BrowserRouter basename={basename}>
  <App />
</BrowserRouter>*/
);

/* StrictMode renders components twice (on dev but not production) in order to detect any problems with your code and warn you about them (which can be quite useful). */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
